import { render, staticRenderFns } from "./LevelManagement.vue?vue&type=template&id=72bf0839&scoped=true"
import script from "./LevelManagement.vue?vue&type=script&lang=js"
export * from "./LevelManagement.vue?vue&type=script&lang=js"
import style0 from "./LevelManagement.vue?vue&type=style&index=0&id=72bf0839&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf0839",
  null
  
)

export default component.exports